import { daysInMonth, monthKeyOf } from './calendar.js';
import { isDone } from './done.js';
/**
 * второй месяц: первый месяц — только наблюдение, со второго у каждого навыка
 * может быть цель «сколько раз в месяц». начало — первая отметка в матрице или
 * первая фиксация дня, поэтому хранить отдельную дату не нужно.
 */
export const FIRST_MONTH_DAYS = 30;
function addDays(day, n) {
    const d = new Date(`${day}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
}
export function usageStart(state) {
    let start = null;
    for (const h of state.history)
        if (!start || h.date < start)
            start = h.date;
    for (const k of state.skills) {
        for (const d of [...Object.keys(k.done), ...Object.keys(k.hours)]) {
            if (isDone(k, d) && (!start || d < start))
                start = d;
        }
    }
    return start;
}
/** первый день второго месяца */
export function secondMonthFrom(state) {
    const start = usageStart(state);
    return start ? addDays(start, FIRST_MONTH_DAYS) : null;
}
export function isSecondMonth(state, today) {
    const from = secondMonthFrom(state);
    return from !== null && today >= from;
}
export function goalStatus(skill, today) {
    const month = monthKeyOf(today);
    const days = daysInMonth(month);
    const dayOfMonth = Number(today.slice(8, 10));
    let done = 0;
    for (let d = 1; d <= days; d++) {
        const key = `${month}-${String(d).padStart(2, '0')}`;
        if (isDone(skill, key))
            done += 1;
    }
    const left = days - dayOfMonth + (isDone(skill, today) ? 0 : 1);
    const goal = skill.goal ?? null;
    if (!goal)
        return { done, goal: null, left, impossible: false, behind: false };
    const needed = Math.floor((goal * dayOfMonth) / days);
    return { done, goal, left, impossible: done + left < goal, behind: done < needed };
}
/** какой по счету сегодня день ведения матрицы (первый день — 1); null — не начинал */
export function usageDay(state, today) {
    const start = usageStart(state);
    if (!start)
        return null;
    const ms = Date.parse(`${today}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`);
    return Math.floor(ms / 86_400_000) + 1;
}
/** сколько дней с начала ведения до сегодня включительно отмечено хотя бы одной единицей */
export function filledDays(state, today) {
    const start = usageStart(state);
    if (!start)
        return 0;
    const days = new Set();
    for (const k of state.skills) {
        for (const d of [...Object.keys(k.done), ...Object.keys(k.hours)]) {
            if (d >= start && d <= today && isDone(k, d))
                days.add(d);
        }
    }
    return days.size;
}
//# sourceMappingURL=goals.js.map